import React from 'react'
import { Main } from './components'

const OrdersShipped = () => <Main />

export default OrdersShipped
